import { ISTacticKey } from '@ess/integrated-search/shared/utils';

import { ISTacticsEnum } from '../enums';

export const IS_TACTICS_KEYS: { [key in ISTacticsEnum]: ISTacticKey } = {
  [ISTacticsEnum.CHANNEL_OVERLAP]: 'channelOverlap',
  [ISTacticsEnum.LANDING_PAGE_OPTIMISATION]: 'landingPageOptimisation',
  [ISTacticsEnum.SEARCH_GAPS]: 'searchGaps',
};
